/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import ProductsOverview, {
	IndustrySectionProduct,
} from "@/components/customCopmonent/landingSection/ProductsOverview";
import HeroSection from "@/components/heroSection/hero-section";
import { CtaSection } from "@/components/customCopmonent/landingSection/cta-section";
import WhyChooseUs from "@/components/customCopmonent/whyChooseUs";
import LogosCrousal from "@/components/clientLogoSection/LogosCrousal";
import StatsComponent from "@/components/customCopmonent/landingSection/StatsComponent";
import WorldWideProjects from "@/components/customCopmonent/AnimatedImageSlider";
import IndustriesWeServe from "../components/customCopmonent/IndustriesWeServer";
import Seo from "@/components/Seo";

export default function LandingPage() {
	return (
		<div className="min-h-screen bg-background text-foreground">
			<Seo
				titleKey="seo.home.title"
				descriptionKey="seo.home.description"
				path="/"
			/>
			<Navigation />
			<HeroSection /> {/* DARK */}
			<StatsComponent /> {/* LIGHT */}
			<WorldWideProjects /> {/* DARK */}
			<ProductsOverview /> {/* LIGHT */}
			<IndustriesWeServe /> {/* DARK */}
			<LogosCrousal /> {/* LIGHT */}
			<WhyChooseUs /> {/* DARK */}
			<CtaSection /> {/* LIGHT */}
			<FooterSection /> {/* DARK */}
		</div>
	);
}
